'use client'

import { useFontLoader } from '@/hooks/useFontLoader'

export function FontLoaderWrapper({ children }: { children: React.ReactNode }) {
  useFontLoader()
  return <>{children}</>
}
